import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0.6, 0),
  },
}))
